import { PromptTemplateCategory } from '../types';

export const educational: PromptTemplateCategory = {
  title: "शैक्षणिक",
  icon: "🧠",
  templates: [
    {
      title: "सरल व्याख्या",
      content: `[टीके कैसे प्रतिरक्षा प्रणाली को प्रशिक्षित करते हैं] विषय को श्रोताओं के लिए स्पष्ट और आकर्षक तरीके से समझाएं।
- कल्पना करें कि आप इसे [एक जिज्ञासु किशोर को समझा रहे हैं जिसे विज्ञान की पृष्ठभूमि नहीं है]।
- एक सम्बंधित उपमा का उपयोग करें: [इसकी तुलना अग्नि शमन अभ्यास से करें — आप किसी चीज़ के लिए अभ्यास करते हैं ताकि जब असली स्थिति आए तो आप तैयार हों]।
- शब्दजाल से बचें; जब कोई तकनीकी शब्द आवश्यक हो, तो उसे तुरंत सरल भाषा में परिभाषित करें।
- गर्मजोशी भरे, प्रोत्साहक लहजे में लिखें जो श्रोता को स्मार्ट महसूस कराए, न कि नीचा दिखाए।`
    },
    {
      title: "वृत्तचित्र वॉयसओवर",
      content: `एक वृत्तचित्र शैली का वॉयसओवर वर्णन लिखें।
- विषय: [बैंकॉक के स्ट्रीट फूड विक्रेताओं का दैनिक जीवन]।
- दृष्टिकोण: [उन व्यंजनों के पीछे का शिल्प, गर्व और पीढ़ी-दर-पीढ़ी ज्ञान जो सरल दिखते हैं लेकिन उनमें महारत हासिल करने में वर्षों लगते हैं]।
- स्वर: [सम्मानजनक, जीवंत और अविचलित — दृश्यों को साँस लेने दें]।
- संवेदी विवरण शामिल करें जो श्रोता को वातावरण की कल्पना करने और महसूस करने में मदद करें: [कड़ाही की छन-छन, सुबह के बाज़ार की नमी, एक विक्रेता के सटीक हाथ की गतिविधियाँ जिसने यह दस हज़ार बार किया है]।
- तात्कालिकता के लिए वर्तमान काल में लिखें।`
    },
    {
      title: "निर्देशित ध्यान",
      content: `सुनने के लिए डिज़ाइन की गई एक निर्देशित ध्यान स्क्रिप्ट लिखें।
- लक्ष्य: [एक लंबे कार्यदिवस के बाद तनाव मुक्त करना और शाम में आराम से प्रवेश करना]।
- श्रोता को कल्पना करने के लिए मार्गदर्शन करें [सूर्यास्त के समय एक शांत झील का किनारा — पानी पर गर्म रोशनी, हल्की हवा, दूर से पक्षियों की रात के लिए बसने की आवाज़]।
- स्वर: [शांत, अविचलित और ज़मीन से जुड़ा]।
- अनुमानित बोलने की अवधि: [8 मिनट]।
- निर्देशों के बीच भरपूर प्राकृतिक विराम ("..." से चिह्नित) का उपयोग करें। वाक्य छोटे और कोमल रखें। ऊर्जा में अचानक बदलाव से बचें।`
    }
  ]
};
